import { withChartLayout } from 'components/common';
import AllergyInformation from 'components/features/chart/admission-history/allergy-information/AllergyInformation';

const AllergyInformationPage = withChartLayout('Allergy Information')(AllergyInformation);
export default AllergyInformationPage;
